<po-page-list
  p-title="Relatório - Saldo Expedição"
  [p-breadcrumb]="breadcrumb"
  [p-filter]="filterSettings"
>
  <div class="po-row">
    <po-button class="po-md-2 po-mb-2" p-kind="secondary" p-label="Excel" (p-click)="gerarExcel()" > </po-button>
  </div>

  <po-table class="po-sm-12 po-md-12 po-lg-12"
    [p-hide-select-all]="true"
    [p-sort]="true"
    [p-striped]="true"
    [p-columns]="tabelaPrincipalColunas"
    [p-items]="tabelaPrincipalItens"
    p-hide-columns-manager="false"
    p-spacing="small"
    [p-filter-type]="poSearchFilterMode"
    p-hide-table-search="false"
  ></po-table>
</po-page-list>

<po-modal #advancedFilterModal p-title="Filtros" [p-primary-action]="advancedFilterPrimaryAction">
  <form #f="ngForm">
     <po-input
      class="po-md-6"
      name="CB8LOTECTL"
      [(ngModel)]="tabelaPrincipalFiltro.dados.CB8LOTECTL"
      p-label="Lote"
      [p-maxlength]="8"
    >
    </po-input>

    <po-lookup
      class="po-md-6"
      name="CB8PRODUTO"
      [(ngModel)]="tabelaPrincipalFiltro.dados.CB8PRODUTO"
      p-field-label="CB1DESC"
      p-field-value="CB1COD"
      p-label="Produto"
      [p-columns]="columnsProdutoFilters"
      [p-field-format]="fieldFormaterProdutoFilters"
      [p-filter-service]="produtoLookupService"
      [p-advanced-filters]="advancedProdutoFilters"
      [p-literals]="{ modalTitle: 'Produto' }"
      [p-filter-params]="{CB1MSBLQL: '2'}"
    ></po-lookup>

    <po-lookup
      class="po-md-6"
      name="CB8LOCAL"
      [(ngModel)]="tabelaPrincipalFiltro.dados.CB8LOCAL"
      p-field-label="CNNRDESCRI"
      p-field-value="CNNRCODIGO"
      p-label="Armazém"
      [p-columns]="columnsArmazemFilters"
      [p-field-format]="fieldFormaterArmazemFilters"
      [p-filter-service]="armazemLookupService"
      [p-advanced-filters]="advancedArmazemFilters"
      [p-filter-params]="{CNNRCODIGO_IN: 'ER,ET,OR,OT,98'}"
      [p-literals]="{ modalTitle: 'Armazém' }"
      [p-multiple]="true"
    ></po-lookup>
  </form>
</po-modal>
